import React from "react";
import styled from "@emotion/styled";

import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import SidebarNavList from "./SidebarNavList";

const Title = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  padding: ${(props) => props.theme.spacing(4)}
    ${(props) => props.theme.spacing(7)} ${(props) => props.theme.spacing(1)};
  opacity: 0.4;
  text-transform: uppercase;
  display: block;
`;

const SidebarNavSection = (props) => {
  const {
    title,
    titleKey,
    pages,
    className,
    component: Component = "nav",
    ...rest
  } = props;
  const { t } = useTranslation();
  const resolvedTitle = titleKey ? t(titleKey) : title;

  return (
    <Component {...rest}>
      {resolvedTitle && <Title variant="subtitle2">{resolvedTitle}</Title>}
      <SidebarNavList pages={pages} depth={0} />
    </Component>
  );
};

export default SidebarNavSection;
